// extracted by mini-css-extract-plugin
export default {"sliderContainer":"xdQss0DbA1"};